import React, { useEffect, useRef } from 'react'
import Page from '../components/Page'
import Video from '../components/Main/Video'
import Link from 'next/link'
import LazyImage from '../components/LazyImage'
import LargeButtons from '../components/Main/LargeButtons'
import Script from 'next/script'
import RowList from '../components/Main/RowList'

const DoubleDonationWidget = () => {
  return (
    <div className='dd-wrapper'>
      <div className='double-donation-field'>
        <div id='dtd-plugin'></div>
        <Script
          src='https://doublethedonation.com/api/js/ddplugin.js'
          strategy='afterInteractive'
          onLoad={() => {
            const dtd_plugin_node = document.getElementById('dtd-plugin')
            const dtd_plugin_config = {
              sections: ['payroll-giving', 'match', 'volunteer']
            }

            // Safely call the plugin
            if (window.doublethedonation?.plugin?.v2?.load_plugin) {
              window.doublethedonation.plugin.v2.load_plugin(
                dtd_plugin_node,
                'JKmMd4C7qFbOgQNW',
                dtd_plugin_config
              )
            }
          }}
        />
      </div>
    </div>
  )
}

export default function Donate (props) {
  const { title: heading, content: content, slug: slug } = props.wp

  const {
    //Large Buttons
    large_buttons: largeButtons,

    //Image
    image: image,

    //Video
    include_video: includeVideo,
    video_poster: videoPoster,
    video_url: videoUrl,
    video_copy: videoCopy,

    //Payroll Giving
    include_payrollgiving: includePayrollGiving,
    payrollgiving_copy: payrollGivingCopy
  } = props.acf

  return (
    <React.Fragment>
      <Page
        title={heading.rendered}
        slug={'/' + slug}
        body={
          'This is the donation page for supporting The Quell Foundation. To donate follow one of the links below.'
        }
      >
        <main id='content'>
          <div className='donate-hero'>
            <LazyImage
              key={image.ID}
              src={image.url}
              alt={image?.alt || image?.name || 'Quell'}
              containClass='donate-img-contain'
            />
            {/* <h1
              className='heading2 text-center'
              dangerouslySetInnerHTML={{ __html: heading.rendered }}
            /> */}
            <div
              className='body-copy'
              dangerouslySetInnerHTML={{
                __html: content.rendered //props.page.fullArticle.content.rendered
              }}
            />
            <LargeButtons buttons={largeButtons} />
          </div>

          {/* Double Donation */}
          {includePayrollGiving && (
            <>
              {payrollGivingCopy && (
                <div
                  className='dd-copy'
                  dangerouslySetInnerHTML={{ __html: payrollGivingCopy }}
                />
              )}
              <DoubleDonationWidget />
            </>
          )}

          {/* Video */}
          {includeVideo && (
            <div className='donate-video-section'>
              {videoCopy && (
                <div
                  className='video-copy'
                  dangerouslySetInnerHTML={{ __html: videoCopy }}
                />
              )}
              <Video poster={videoPoster} url={videoUrl} />
            </div>
          )}
        </main>
      </Page>
    </React.Fragment>
  )
}
